<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box" v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                       Lesson Plan Execution
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Academic Year" outlined @change="getStd"
                        persistent-hint hint="Please Select Academic Year" />
                </v-col>
                <v-col sm="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
                        :items="std_div_list" item-text="std" label="Standard" outlined @change="getDiv" persistent-hint
                        hint="Please Select Standard" />
                </v-col>
                <v-col sm="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="div" return-object :items="div_list"
                        item-text="div_name" label="Division" outlined persistent-hint hint="Please Select Division" />
                </v-col>
                <v-col sm="2" v-if="div_list != null">
                    <v-btn class="mt-6 button" @click="proceed()">Proceed</v-btn>
                </v-col>
            </v-row>
            <v-btn class="mb-2" v-if="course_execution_list != ''" rounded color="success" outlined @click="fnExcelReport('my-table-id', 'LessonPlanningExecutionReport')" :loading="loader">
                        <v-icon  color="success">mdi-export</v-icon>Export
            </v-btn>
            <span v-if="course_execution_list!=''">
            <div id="my-table-id">
            <v-data-table  dense :headers="headers1" :items="course_execution_list"  class="elevation-1 mytable" :items-per-page="-1">  
            </v-data-table>
            </div>
            </span>
        </v-card>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    props: {
          course: String,
      },
    data() {
        return {
            search: "",
            snackbar_msg: "",
            color: "",
            snackbar: false,
            ay_std_div_list: null,
            sel_ay_data: null,
            show_tt: false,
            std_div_list: null,
            sel_std_data: null,
            div_list: null,
            div: null,
            overlay: false,
            course_execution_list:[],
            headers1: [
                    {
                        text: "Sr. No.",
                        sortable: false,
                        value: "srno",
                    },
                    {
                        text: "Academic Year",
                        align: "center",
                        sortable: false,
                        value: "academicyear",
                    },
                    {
                        text: "Standard",
                        align: "center",
                        sortable: false,
                        value: "standard",
                    },
                    {
                        text: "Division",
                        align: "center",
                        sortable: false,
                        value: "division",
                    },
                    {
                        text: "Lecture No.",
                        align: "center",
                        sortable: false,
                        value: "lecture_no",
                    },
                    {
                        text: "Unit",
                        align: "center",
                        sortable: false,
                        value: "unit",
                    },
                    {
                        text: "Topic",
                        align: "center",
                        sortable: false,
                        value: "topic",
                    },
                    {
                        text: "Subject",
                        align: "center",
                        sortable: false,
                        value: "course",
                    },
                    {
                        text: "Execution Date",
                        align: "center",
                        sortable: false,
                        value: "execution_date",
                    },
                ],
        };
    },
    methods: {
        fnExcelReport(id, name) {
  let tab_text = `<table border='1px'>
    <tr>
      <th>Sr. No</th>
      <th>Academic Year</th>
      <th>Standard</th>
      <th>Division</th>
      <th>Lecture No.</th>
      <th>Unit</th>
      <th>Topic</th>
      <th>Subject</th>
      <th>Execution Date</th>
     
    </tr>`;

  this.course_execution_list.forEach((s, index) => {
    tab_text += `
    <tr>
        <td>${index + 1}</td>
        <td>${s.academicyear}</td>
        <td>${s.standard}</td>
        <td>${s.division}</td>
        <td>${s.lecture_no}</td>
        <td>${s.unit}</td>
        <td>${s.topic}</td>
        <td>${s.course}</td>
        <td>${s.execution_date}</td>
      </tr>`;
  });

  tab_text += '</table>';

  const blob = new Blob([tab_text], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // For IE
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    // For modern browsers
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }
},
        getStd() {
            // this.std_div_list = ["All"];
            // this.sel_std_data = "All";
            this.div_list = null;
            this.div = null;
            this.std_div_list = this.sel_ay_data.std_list;
            this.std_div_list = this.sel_ay_data.std_list;
            // this.std_div_list.unshift("All");
            // this.sel_std_data = this.std_div_list[0];
        },
        getDiv() {
            // this.div_list = ["All"];
            // this.div = "All";
            this.div_list = this.sel_std_data.div_list;
            // this.div_list.unshift("All");
            // this.div = this.div_list[0];
            if (this.div_list.length == 0) {
                alert("No division found!!!");
                this.div_list = null;
            }
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        async proceed(){
            this.course_execution_list=[]
            let div = this.div.div_id;
                if (this.div.div_id) {
                    div = this.div.div_id;
                } else {
                    div = this.div;
                }
            const data = {
                id: this.sel_ay_data.ay_id,
                standard: this.sel_std_data.std_id,
                division: div,
                course: this.course
            };
            try {
                const res = await axios.post("/LessonPlanExecution/getPlanExecution",data);
                    if (res.data.flag == "YES") {
                       this.course_execution_list = res.data.course_execution_list
                       if(this.course_execution_list==''){
                         this.showSnackbar("#b71c1c", "No Execution Data Available.."); // show snackbar
                       }
                    }
                    else if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
                    }
                    else{
                        this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
                    }
                }
                catch (error) {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                } finally 
                {
                    
                }
        },
        onload() {
            //this.uid = localStorage.getItem("EPS-uid")
            axios
                .post("/commonAPI/get_ay_std_div")
                .then((res) => {
                    this.ay_std_div_list = res.data.data;
                   // this.sel_ay_data = res.data.curr_ay;
                })
                .catch((error) => {
                    alert("Somthing went wrong!!!");
                })
                .finally(() => {
                    //stop loader
                });
        }
    },
    mounted() {
        this.onload();
    },
};
</script>
<style scoped>
.mytable /deep/ thead th {
    background: #0f2027;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027);
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #2c5364, #203a43, #0f2027);
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}
</style>

